import * as yup from 'yup';
import pcsPlanFormModel from './pcsPlanFormModel';
import { EMAIL_EXPRESSION } from '../../../app/utils/constant';
import { imcNumberValidationSchema } from '../../../app/models/pcsEnrolment/registrationValidationSchema';

const {
  formField: {
    AccreditedContinuingEducationActivity,
    WorkBasedLearning,
    PracticeReview,
    EngagedInPracticeOfMedicine,
    Title,
    FirstName,
    Surname,
    IMCNumber,
    EmailAddress,
    ReviewerComments,
    MyReflection
  }
} = pcsPlanFormModel;

export const plannedActivitiesValidationSchema = yup.object().shape({
  [AccreditedContinuingEducationActivity.name]: yup.string().required(`${AccreditedContinuingEducationActivity.requiredErrorMsg}`)
    .max(AccreditedContinuingEducationActivity.maxStringCount, AccreditedContinuingEducationActivity.maxStringLengthErrorMsg),
  [WorkBasedLearning.name]: yup.string().required(`${WorkBasedLearning.requiredErrorMsg}`).max(WorkBasedLearning.maxStringCount, WorkBasedLearning.maxStringLengthErrorMsg),
  [PracticeReview.name]: yup.string().max(PracticeReview.maxStringCount, PracticeReview.maxStringLengthErrorMsg)
    .when([EngagedInPracticeOfMedicine.name], ([engagedInPracticeOfMedicine]) => {
      if (engagedInPracticeOfMedicine === true) {
        return yup.string().required(`${PracticeReview.requiredErrorMsg}`);
      }
      return yup.string().max(PracticeReview.maxStringCount, PracticeReview.maxStringLengthErrorMsg);
    })
});

export const reviewerDetailsValidationSchema = yup.object().shape({
  [Title.name]: yup.string().required(`${Title.requiredErrorMsg}`),
  [FirstName.name]: yup.string().required(`${FirstName.requiredErrorMsg}`),
  [Surname.name]: yup.string().required(`${Surname.requiredErrorMsg}`),
  [IMCNumber.name]: imcNumberValidationSchema,
  [EmailAddress.name]: yup.string().matches(EMAIL_EXPRESSION, `${EmailAddress.typeError}`)
});

export const reviewerValidationSchema = yup.object().shape({
  [ReviewerComments.name]: yup.string().test('len', `${ReviewerComments.maxStringLengthErrorMsg}`,
    val => val !== undefined && val.length <= ReviewerComments.maxStringCount)
});

export const feedbackValidationSchema = yup.object().shape({
  [MyReflection.name]: yup.string().required(`${MyReflection.requiredErrorMsg}`)
    .max(MyReflection.maxStringCount, MyReflection.maxStringLengthErrorMsg)
});

export const confirmReviewerDetailsValidationSchema = yup.object().shape({
  [IMCNumber.name]: imcNumberValidationSchema,
  [Title.name]: yup.string().test(`${Title.name}`,
    `${Title.requiredErrorMsg}`,
    function (title) {
      if (title === "") {
        return false;
      }
      return true;
    }
  ),
  [FirstName.name]: yup.string().test(`${FirstName.name}`,
    `${FirstName.requiredErrorMsg}`,
    function (firstName) {
      if (firstName === "") {
        return false;
      }
      return true;
    }
  ),
  [Surname.name]: yup.string().test(`${Surname.name}`,
    `${Surname.requiredErrorMsg}`,
    function (surname) {
      if (surname === "") {
        return false;
      }
      return true;
    }
  ),
  [EmailAddress.name]: yup.string().test(`${EmailAddress.name}`,
    `${EmailAddress.typeError}`,
    function (emailAddress) {
      if (emailAddress === undefined) {
        return true;
      }
      else if (emailAddress === "") {
        return false;
      }
      else {
        return EMAIL_EXPRESSION.test(emailAddress);
      }
    }
  )
});
